import { BrowserRouter } from "react-router-dom";
import * as en from './translations/en.json';
import * as fr from './translations/fr.json';
import * as nl from './translations/nl.json';

export const languages = [
    { locale: 'fr', name: "French", flag: <img src="/flags/FR.png" alt="FR" className="min-w-[24px] w-[24px]" /> },
    { locale: 'en', name: "English", flag: <img src="/flags/EN.png" alt="EN" className="min-w-[24px] w-[24px]" /> },
    { locale: 'nl', name: "Nederlands", flag: <img src="/flags/NL.png" alt="NL" className="min-w-[24px] w-[24px]" /> },
]
const detectLanguage = () => languages.find(x => x.locale === window.location.pathname.split('/')[1])?.locale || ''

export function useLocale() {
    return [
        detectLanguage(),
        locale => window.location.replace(`/${locale}/${window.location.pathname.split('/').slice(detectLanguage() ? 2 : 1).join('/')}${window.location.search}`)
    ]
}

export function LocalizedRouter({ children }) {
    let [locale, setLocale] = useLocale()
    if (!locale) setLocale(languages[0].locale)

    return locale && <BrowserRouter basename={locale}>
        {children}
    </BrowserRouter>
}

export const useTranslations = () => {
    const [currentLocale] = useLocale()
    return (key, variables = {}, locale = currentLocale) => {
        locale = locale.toLowerCase()
        let text = translations[locale]?.[key] || key
        if (key && locale !== languages[0].locale && !translations[locale]?.[key]) console.warn(`Missing translation "${key}" for locale ${locale}`)
        for (let variable in variables) text = text.replace(new RegExp(`\\{${variable}\\}`, 'g'), variables[variable])
        return text
    }
}

const translations = { en, fr, nl }